import { useState, useEffect } from 'react';
import { getProductRecommend } from '@base/product/services';
import { IRecommendListData } from 'base/interfaces/product';

export type IProdRecommend = {
    listLoading: boolean;
    getData: (variantId: string, currentPage: number) => Promise<IRecommendListData>;
} & IRecommendListData;

export default function useProdRecommend(variantId: string, page: number): IProdRecommend {
    const [listLoading, setListLoading] = useState<boolean>(false)
    const [pageData, setPageData] = useState<IRecommendListData>({
        variants: [],
        page: 1,
        totalPage: 0
    })

    const getData = async (variantId: string, currentPage): Promise<IRecommendListData> => {
        try {
            setListLoading(true)
            const res = await getProductRecommend({
                variantId,
                page: currentPage || page || 1,
                size: 30
            })
            const { variants, ...rest } = res || {}
            const newVariants = pageData.variants.concat(variants)

            // TODO: wholesale remove
            // newVariants.forEach(item=>item.dealerShopPriceExchangeDisplay = '$5.00')

            const newData = {
                ...rest,
                variants: newVariants
            }
            setPageData(newData)
            return newData
        } catch (err) {
            return pageData
        } finally {
            setListLoading(false)
        }
    }

    useEffect(() => {
        (variantId && page) && getData(variantId, page)
    }, [variantId, page])

    return {
        ...pageData,
        getData,
        listLoading,
    }
}
